export default __webpack_public_path__ + "static/media/solucao-10.d4a51d1c.webp";